<template>
  <div v-loading="loading">
    <!-- <h3 class="minor-title"><span class="danger-text">*</span> 预算调整明细</h3> -->
    <component
      :is="tableComponent"
      :max-height="500"
      :getElSummaries="summaryMethod"
      :data="tableData"
      :tableColumnData="tableColumnData"
      show-summary
      v-bind="tableExtraProps">
      <template slot="firstDeptId" slot-scope="{ scope }">
        <!-- :disabled="scope.$index == 1 && (alterType == 2 || alterType == 3 || alterType == 4)" -->
        <el-select :disabled="tableDisabled || String(alterType) === '2'" v-model="tableData[scope.$index].firstDeptId"
          filterable clearable placeholder="请选择预算一级部门"
          class="mid-el-width"
          @change="handleRepeatCheck(scope.$index, 'firstDeptId');setFirstDeptName(scope.$index);emitDetailList(scope.$index, 'firstDeptId');
          ">
          <el-option v-for="item in firstDeptList" :disabled="item.disabled === 1 || item.disabled === '1'"
            :key="item.dicId" :label="item.dicName" :value="item.dicId"></el-option>
        </el-select>
      </template>
      <!-- V3.6.2：原「事业部」列改为「是否待分摊」，变更后触发金额重查 queryModey(shareTypeNo) -->
      <template slot="shareTypeNo" slot-scope="{ scope }">
        <el-select :disabled="tableDisabled" v-model="tableData[scope.$index].shareTypeNo" filterable clearable placeholder="请选择是否待分摊"
          class="mid-el-width" @change="handleRepeatCheck(scope.$index, 'shareTypeNo');setShareTypeName(scope.$index);emitDetailList(scope.$index, 'shareTypeNo')">
          <el-option v-for="item in shareTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </template>
      <template slot="subjectsCatId" slot-scope="{ scope }">
        <!-- :disabled="scope.$index == 1 && (alterType == 1 || alterType == 4)" -->
        <el-select :disabled="tableDisabled || String(alterType) === '1'" v-model="tableData[scope.$index].subjectsCatId" filterable clearable placeholder="请选择预算大类"
          class="mid-el-width"  @change="handleRepeatCheck(scope.$index, 'subjectsCatId');
            setSubjectsCatIdByExtType3(scope.$index);
            setChildTypeList(scope.$index);
          emitDetailList(scope.$index, 'subjectsCatId');" >
          <el-option v-for="item in budgetTypeList" :key="item.dicId" :label="item.dicName"
            :value="item.dicId"></el-option>
        </el-select>
      </template>
      <template slot="subjectsTypeId" slot-scope="{ scope }">
        <!-- :disabled="scope.$index == 1 && alterType == 4"  0501注释 -->
        <el-select :disabled="tableDisabled" v-model="tableData[scope.$index].subjectsTypeId" filterable clearable placeholder="请选择预算类型"
          class="mid-el-width" @change="handleRepeatCheck(scope.$index, 'subjectsTypeId');
            setSubjectsTypeName(scope.$index);
          emitDetailList(scope.$index, 'subjectsTypeId');
          ">
          <el-option v-for="item in childTypeList[scope.$index]" :key="item.dicId + '_' + scope.$index" :label="item.dicName"
            :value="item.dicId"></el-option>
        </el-select>
      </template>
      <!-- <template slot="year" slot-scope="{ scope }">
        <el-date-picker v-model="tableData[scope.$index].year" type="year" clearable value-format="yyyy"
          class="mid-el-width" @change="
            handleDateChange(scope.$index, 'year');
          emitDetailList(scope.$index, 'year');
          " placeholder="请选择年份">
        </el-date-picker>
      </template> -->
      <template slot="cycleMonth" slot-scope="{ scope }">
        <el-select :disabled="tableDisabled" v-model="tableData[scope.$index].cycleMonth" filterable clearable placeholder="请选择预算周期" class="mid-el-width"
          @change="handleRepeatCheck(scope.$index, 'cycleMonth');
            handleDateChange(scope.$index, 'cycleMonth');
          emitDetailList(scope.$index, 'cycleMonth');
          ">
          <el-option v-for="item in monthList" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
      </template>
      <template slot="adjustAmount" slot-scope="{ scope }">
        <el-input-number :disabled="tableDisabled" clearable :min="-99999999.99" :max="99999999.99" :precision="2" class="table-input"
          :controls="false" v-model.number="tableData[scope.$index].adjustAmount" placeholder="请输入调整金额" @change="
            adjustAmountChange(scope.$index, true);
          emitDetailList();
          "></el-input-number>
      </template>
      <template slot="budgetAmount" slot-scope="{ scope }">
        <el-input-number :disabled="tableDisabled" clearable :min="0" :max="99999999.99" :precision="2" class="table-input" :controls="false"
          v-model.number="tableData[scope.$index].budgetAmount" placeholder="请输入年初预算金额"
          @change="emitDetailList()"></el-input-number>
      </template>
      <template slot="adjustBeforeAmount" slot-scope="{ scope }">
        <el-input-number :disabled="tableDisabled" clearable :min="0" :max="99999999.99" :precision="2" class="table-input" :controls="false"
          v-model.number="tableData[scope.$index].adjustBeforeAmount" placeholder="请输入调整后半年度预算金额"
          @change="emitDetailList()"></el-input-number>
      </template>

      <template slot="budgetImplementedAmount" slot-scope="{ scope }">
        <el-input-number :disabled="tableDisabled" clearable :min="0" :max="99999999.99" :precision="2" class="table-input" :controls="false"
          v-model.number="tableData[scope.$index].budgetImplementedAmount" placeholder="请输入预算已执行金额"
          @change="emitDetailList()"></el-input-number>
      </template>
      <template slot="freezeAmount" slot-scope="{ scope }">
        <el-input-number :disabled="tableDisabled" clearable :min="0" :max="99999999.99" :precision="2" class="table-input" :controls="false"
          v-model.number="tableData[scope.$index].freezeAmount" placeholder="请输入预算已冻结金额"
          @change="emitDetailList()"></el-input-number>
      </template>
      <template slot="adjustAfterRemainAmount" slot-scope="{ scope }">
        <el-input-number :disabled="tableDisabled" clearable :min="0" :max="99999999.99" :precision="2" class="table-input" :controls="false"
          v-model.number="tableData[scope.$index].adjustAfterRemainAmount" placeholder="请输入调整后剩余金额"
          @change="emitDetailList()"></el-input-number>
      </template>
      <template slot="operate" slot-scope="{ scope }">
        <div class="flex">
          <!-- <el-button type="warning" icon="el-icon-plus" circle></el-button>
          <el-button type="danger" icon="el-icon-minus" circle></el-button> -->
          <i class="el-icon-minus pointer" style="color: #F7B221;" v-if="showDelBtn" @click="handleDel(scope.$index)"></i>
          <i class="el-icon-plus pointer" style="color: #F7B221;" @click="handleAdd(scope.$index)"></i>
        </div>
        <!-- <el-button type="text" @click="handleDelete(scope.$index)">删除</el-button> -->
      </template>
      <template slot="budgetCycle" slot-scope="{ scope }">
        <el-select :disabled="tableDisabled"
          v-model="tableData[scope.$index].budgetCycle"
          filterable clearable placeholder="请选择预算周期" class="mid-el-width"
          @change="
            handleBudgetCycleChange(scope.$index, true);
            emitDetailList(scope.$index, 'budgetCycle');
          ">
          <el-option v-for="item in budgetCycleList" :key="item.id" :label="item.label" :value="item.val"></el-option>
        </el-select>
      </template>
      <template slot="grantedMonth" slot-scope="{ scope }">
        <!-- {{ tableData[scope.$index].grantedMonthList }} -->

        <!-- {{ scope.row.grantedMonthList }}
        {{ tableData[scope.$index].grantedMonth }} -->
        <!-- {{ scope.row.grantedMonthList }} -->
        <el-select :disabled="tableDisabled"
          v-if="scope.row.grantedMonthList && scope.row.grantedMonthList.length > 0"
          v-model="tableData[scope.$index].grantedMonth"
          filterable clearable placeholder="请选择待授予调整月份" class="mid-el-width"
          @change="
            emitDetailList(scope.$index, 'grantedMonth');
          ">
          <el-option v-for="item in scope.row.grantedMonthList" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
        <!-- <span v-else></span> -->
      </template>
      <template slot="adjustGrantedAmount" slot-scope="{ scope }">
        <el-input-number v-if="scope.row.grantedMonthList && scope.row.grantedMonthList.length > 0"
          :disabled="tableDisabled" clearable :min="-99999999.99" :max="99999999.99" :precision="2" class="table-input" :controls="false"
          v-model.number="tableData[scope.$index].adjustGrantedAmount" placeholder="请输入已授予调整金额"
          @change="setAfterGrantedAmount(scope.$index);emitDetailList()"></el-input-number>
        <!-- <span v-else></span> -->
      </template>
      <template slot="pendingGrantedMonth" slot-scope="{ scope }">
        <el-select :disabled="tableDisabled"
          v-if="scope.row.pendingGrantedMonthList && scope.row.pendingGrantedMonthList.length > 0"
          v-model="tableData[scope.$index].pendingGrantedMonth"
          filterable clearable placeholder="请选择已授予调整月份" class="mid-el-width"
          @change="
            emitDetailList(scope.$index, 'pendingGrantedMonth');
          ">
          <el-option v-for="item in scope.row.pendingGrantedMonthList" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
        <!-- <span v-else></span> -->
      </template>
      <template slot="adjustPendingGrantedAmount" slot-scope="{ scope }">
        <el-input-number v-if="scope.row.pendingGrantedMonthList && scope.row.pendingGrantedMonthList.length > 0"
          :disabled="tableDisabled" clearable :min="-99999999.99" :max="99999999.99" :precision="2" class="table-input" :controls="false"
          v-model.number="tableData[scope.$index].adjustPendingGrantedAmount" placeholder="请输入待授予调整金额"
          @change="setafterPendingGrantedAmount(scope.$index);emitDetailList()"></el-input-number>
        <!-- <span v-else></span> -->
      </template>
    </component>
  </div>
</template>
<script>
/**
 * 年度预算调整明细表格（ext1=1/2/5 等）
 * V3.6.2：隐藏事业部列，新增「是否待分摊」下拉；唯一性与 queryAlterMoney 入参均含 shareTypeNo
 */
// import BusinessUnitSelect from "@/common/components/BusinessUnitSelect";
import { awaitWrapper, sleep } from "@/common/utils/assist.js"; //
import {
  getOriTree, // 使用预算大类、科目
  queryAlterMoney, // 调整申请查询预算金额、调整后金额，冻结金额、执行后金额
  queryGrateModey, // 弹性授予获取已授予金额和待授予金额
  // getEhrFirstDepts
} from "../request";
import { addDetailColumnData, sameBudgetTypeColumnData, elasticityColumnData } from "../config";
import {
  SHARE_TYPE_OPTIONS,
  getShareTypeLabel,
  defaultShareTypeNo,
} from "@/modules/yearBudget/constants/shareType.js";
import plus from "library/functions/plus";
import minus from "library/functions/minus";
import isRepeat from 'library/functions/isRepeat'
import AlterVirtualTable from './AlterVirtualTable.vue';

export default {
  components: {
    AlterVirtualTable,
    // BusinessUnitSelect,
  },
  props: {
    dataIndex: {
      default: 0,
      type: Number,
    },
    checkeDeptCodeList: {
      default: () => [],
      type: Array
    },
    tableDisabled: {
      default: false,
      type: Boolean,
    },
    alterType: null,
    detailList: {
      default: () => [{subjectsTypeId: null}],
      type: Array,
    }, // 调整信息
    year: null,
    yearType: null,
    submitParms: {
      default: () => {
        return {
          ext1: null,
        }
      },
      type: Object,
    },
    firstDeptList: {
      default: () => [],
      type: Array,
    }, // 一级部门
    businessUnitList: {
      default: () => [],
      type: Array,
    }, // 事业部
    budgetTypeList: {
      default: () => [],
      type: Array,
    }, 
  },
  watch: {
    // '$store.state.yearBudget.isImportType3DetailList': {
    //   handler: async function (newval) {
    //     if (!newval) {
    //       return
    //     }
    //     this.$store.commit('SET_IS_IMPORT_TYPE3_DETAIL_LIST', false)
    //     // 触发时已校验、无需校验
    //     await sleep(100)
    //     this.setBudgetCycleChange() // 弹性调整预算周期
    //   },
    //   immediate: true,
    // },
    // '$store.state.yearBudget.isImportType1DetailList': {
    //   handler: async function (newval) {
    //     if (!newval) {
    //       return
    //     }
    //     this.$store.commit('SET_IS_IMPORT_TYPE1_DETAIL_LIST', false)
    //   },
    //   immediate: true,
    // },
    detailList: {
      handler: function (newval) {
        this.tableData = []
        if (Array.isArray(newval) && newval.length !== 0) {
          newval.forEach(item => {
            // 重新触发双向绑定
            this.tableData.push({
              ...item,
              _rowKey: item._rowKey || this.genRowKey(),
              firstDeptId: item.firstDeptId || null,
              subjectsCatId: item.subjectsCatId || null,
              subjectsTypeId: item.subjectsTypeId || null,
              businessUnitId: item.businessUnitId || null, // 历史 ext1=3 弹性流程只读兼容
              shareTypeNo: item.shareTypeNo || defaultShareTypeNo,
              shareType: item.shareType || getShareTypeLabel(item.shareTypeNo || defaultShareTypeNo),
              cycleMonth: item.cycleMonth || null,
              adjustAmount: item.adjustAmount || 0,
              budgetAmount: item.budgetAmount || 0,
              adjustBeforeAmount: item.adjustBeforeAmount || 0,
              budgetImplementedAmount: item.budgetImplementedAmount || 0,
              freezeAmount: item.freezeAmount || 0,
              remainAmount: item.remainAmount || 0,
              adjustAfterRemainAmount: item.adjustAfterRemainAmount || 0,
              afterPendingGrantedAmount: item.afterPendingGrantedAmount || 0,

              grantedAmount: item.grantedAmount || 0,
              adjustGrantedAmount: item.adjustGrantedAmount || 0,
              afterGrantedAmount: item.afterGrantedAmount || 0,
              pendingGrantedAmount: item.pendingGrantedAmount || 0,
              adjustPendingGrantedAmount: item.adjustPendingGrantedAmount || 0,
              pendingGrantedMonthList: item.pendingGrantedMonthList || [],
              grantedMonthList: item.grantedMonthList || [],
            })
          })
        }
        this.tableData.forEach((item, index) => {
          if (item.subjectsCatId) {
            this.setInitChildType(index);
          }
        });
      },
      immediate: true,
      deep: true,
    },
    year: {
      handler: function(newval) {
        if (newval) {
          this.setbudgetCycleList()
        }
      },
      immediate: true,
      deep: true
    },
    alterType: {
      handler: function (newval) {
        if (newval == "1") {
          // 相同预算大类调整
          this.tableColumnData = sameBudgetTypeColumnData;
        } else if (newval == "2") {
          // 相同一级部门调整
          this.tableColumnData = sameBudgetTypeColumnData;
        } else if (newval == "3") {
          this.setbudgetCycleList()
          // 相同一级部门调整
          this.tableColumnData = elasticityColumnData;
        } else if (newval == "5") {
          this.tableColumnData = [...sameBudgetTypeColumnData];
          this.tableColumnData = this.tableColumnData.map(item=>{
            if (item.prop === 'adjustAmount') {
              return {
                ...item,
                label: '调整金额'
              }
            }
            return item
          })
        }
      },
      immediate: true,
      deep: true,
    },
    yearType: {
      handler: async function (newval) {
        await sleep(60)
        const firstHalfMonth = [1, 2, 3, 4, 5, 6]
        const secondHalfMonth = [7,8, 9, 10, 11, 12]
        this.monthList = []
        if (this.alterType == '3') { // 弹性调整
          this.setbudgetCycleList()
        } else if (String(newval) === "1") {
          [...firstHalfMonth, ...secondHalfMonth].forEach(item => {
            this.monthList.push({
              id: `${this.year}_${item}`,
              label: `${this.year}年${item}月`,
            })
          })
        } else if (String(newval) === "2") {
          secondHalfMonth.forEach(item => {
            this.monthList.push({
              id: `${this.year-1}_${item}`,
              label: `${this.year-1}年${item}月`,
            })
          })
          firstHalfMonth.forEach(item => {
            this.monthList.push({
              id: `${this.year}_${item}`,
              label: `${this.year}年${item}月`,
            })
          })
        }
      },
      immediate: true,
    },
  },
  computed: {
    tableComponent() {
      return String(this.alterType) === '3' ? 'common-table' : 'alter-virtual-table';
    },
    useCommonTable() {
      return String(this.alterType) === '3';
    },
    tableExtraProps() {
      if (this.useCommonTable) {
        return { spanMethod: this.handleSpanMethod };
      }
      return {};
    },
    showDelBtn() {
      if (['1', '2'].includes(String(this.submitParms.ext1))) {
        if (this.tableData.length > 2) {
          return true
        } else {
          return false
        }
      } else if (['1', '3', '5'].includes(String(this.submitParms.ext1))) {
        if (this.tableData.length > 1) {
          return true
        } else {
          return false
        }
      }
      return true
      // return false
    },
  },
  data() {
    return {
      loading: false,
      shareTypeOptions: SHARE_TYPE_OPTIONS, // V3.6.2 是否待分摊下拉
      tableColumnData: sameBudgetTypeColumnData,
      tableData: [],
      // firstDeptList: [], // 一级部门
      // budgetTypeList: [], // 预算大类
      childTypeList: [[], []], // 预算类型
      // monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      monthList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear();
        },
      },
      budgetCycleList: [], // 预算周期
      spanArr: [], // 用于存储合并信息
      rowKeySeed: 0,
    };
  },
  created() {
    
    // this.getOriInfo(6);
    // this.getEhrFirstDepts()
    // this.getOriInfo(7);
  },
  async mounted() {
    this.loading = true
    await sleep(1000)
    if (this.alterType == '3' && this.tableData.length > 0) {
      this.setBudgetCycleChange()
    }
    this.loading = false
  },
  methods: {
    genRowKey() {
      this.rowKeySeed += 1;
      return 'alter_row_' + this.rowKeySeed;
    },
    setbudgetCycleList() { // 设置弹性调整预算周期
      this.budgetCycleList = [];
      if (this.year && this.yearType && this.alterType && String(this.yearType) === "1") {
        this.budgetCycleList = [
          { id: this.year + '_1_3', label: `${this.year}年${1}月-${this.year}年${3}月`, val: `${this.year}年${1}月-${this.year}年${3}月`},
          { id: this.year + '_4_6', label: `${this.year}年${4}月-${this.year}年${6}月`, val: `${this.year}年${4}月-${this.year}年${6}月`},
          { id: this.year + '_7_9', label: `${this.year}年${7}月-${this.year}年${9}月`, val: `${this.year}年${7}月-${this.year}年${9}月`},
          { id: this.year + '_10_12', label: `${this.year}年${10}月-${this.year}年${12}月`, val: `${this.year}年${10}月-${this.year}年${12}月`},
        ]
      } else {
        this.budgetCycleList = [
          { id: (this.year - 1) + '_7_9', label: `${this.year - 1}年${7}月-${this.year - 1}年${9}月`, val: `${this.year - 1}年${7}月-${this.year - 1}年${9}月`},
          { id: (this.year - 1) + '_10_12', label: `${this.year - 1}年${10}月-${this.year - 1}年${12}月`, val: `${this.year - 1}年${10}月-${this.year - 1}年${12}月`},
          { id: this.year + '_1_3', label: `${this.year}年${1}月-${this.year}年${3}月`, val: `${this.year}年${1}月-${this.year}年${3}月`},
          { id: this.year + '_4_6', label: `${this.year}年${4}月-${this.year}年${6}月`, val: `${this.year}年${4}月-${this.year}年${6}月`},
        ]
      }
    },
    setBudgetCycleChange(isInit, prop) { // 弹性调整 设置预算月份，已授予金额和待授予金额
      this.tableData.forEach((item, index) => {
        if (!isInit) {
          this.handleBudgetCycleChange(index, true, true)
        } 
        this.getGrantedAmount(index, prop)
      })
    },
    handleBudgetCycleChange(index, setCycle, isInit) {
      if (this.tableData[index].budgetCycle) {
        const checkedbudgetCycleId = this.budgetCycleList.find(item => item.val === this.tableData[index].budgetCycle).id
        const currYear = []
        const afterYear = []
        // 已授予金额grantedAmount：预算周期内月份≤当前月的 预算编制+预算已调整金额合计
        for(let i = parseInt(checkedbudgetCycleId.split('_')[1]); i <= parseInt(checkedbudgetCycleId.split('_')[2]); i++) {
          const checkMonth = checkedbudgetCycleId.split('_')[0] + '-' + i + '-01'
          const checkedMonthTime = new Date(checkMonth + ' 00:00:01')
          const currMonthTime = new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 1);
          if (checkedMonthTime <= currMonthTime) {
            currYear.push({
              year: checkedbudgetCycleId.split('_')[0],
              month: i
            })
          } else {
            afterYear.push({
              year: checkedbudgetCycleId.split('_')[0],
              month: i
            })
          }
        }
        if (setCycle && !isInit) {
          this.$set(this.tableData[index], 'grantedMonth', null)
          this.$set(this.tableData[index], 'pendingGrantedMonth', null)
          // "已授予调整金额
          this.$set(this.tableData[index], 'adjustGrantedAmount', null)
          // 已授予调整后金额
          this.$set(this.tableData[index], 'afterGrantedAmount', null)
          // 待授予调整金额
          this.$set(this.tableData[index], 'adjustPendingGrantedAmount', null)
          // 待授予调整后金额
          this.$set(this.tableData[index], 'afterPendingGrantedAmount', null)
          this.tableData[index].grantedMonthList = []
          this.tableData[index].pendingGrantedMonthList = []
        }
        if (setCycle) {
          this.setGrantedMonthList(currYear, index)
          this.setPendingGrantedMonthList(afterYear, index, isInit)
        }
        this.$emit('setDetailList', this.tableData)
      }
    },
    // 弹性调整 设置预算月份,如果没有预算月份，不允许填写已授予调整金额
    setGrantedMonthList(currYear, index) {
      if (!this.tableData[index].budgetCycle) {
        this.tableData.adjustGrantedAmount = null
        return
      }
      const grantedMonthList = []
      currYear.forEach(yearInfo=> {
        grantedMonthList.push({
          id: `${yearInfo.year}_${yearInfo.month}`,
          label: `${yearInfo.year}年${yearInfo.month}月`,
        })
      })
      if (grantedMonthList.length === 0) {
        this.tableData[index].adjustGrantedAmount = null
      }
      this.tableData[index].grantedMonthList = grantedMonthList
      this.$set(this.tableData[index], 'grantedMonthList', grantedMonthList)
      this.$forceUpdate()
    },
    // 已授予调整月份 若预算周期里面的月份都是历史/当前月份，则不允许填写待授予调整金额
    setPendingGrantedMonthList(currYear, index, isInit) {
      if (!this.tableData[index].budgetCycle) {
        this.tableData.adjustPendingGrantedAmount = undefined
        return
      }
      const pendingGrantedMonthList = []
      currYear.forEach(yearInfo=> {
        pendingGrantedMonthList.push({
          id: `${yearInfo.year}_${yearInfo.month}`,
          label: `${yearInfo.year}年${yearInfo.month}月`,
        })
      })
      if (pendingGrantedMonthList.length === 0) {
        this.tableData[index].adjustPendingGrantedAmount = undefined
      }
      this.tableData[index].pendingGrantedMonthList = pendingGrantedMonthList
    },
    // 已授予金额grantedAmount：预算周期内月份≤当前月的 预算编制+预算已调整金额合计
    async getGrantedAmount(index, prop, isInit) {
      // console.log('getGrantedAmount index', index, prop, isInit)
      if (
        !this.tableData[index].firstDeptId ||
        !this.tableData[index].subjectsCatId ||
        !this.tableData[index].subjectsTypeId ||
        !this.tableData[index].businessUnitId
      ) {
        return
      }
      if (!this.validateDetailListByExtType3(index, prop)) {
        return
      }
      if (
        !this.tableData[index].firstDeptId ||
        !this.tableData[index].subjectsCatId ||
        !this.tableData[index].subjectsTypeId ||
        !this.tableData[index].businessUnitId
      ) {
        return
      }
      if (!this.tableData[index].budgetCycle) {
        return
      }
      const params = {
        firstDeptId: this.tableData[index].firstDeptId,
        subjectsCatId: this.tableData[index].subjectsCatId,
        subjectsTypeId: this.tableData[index].subjectsTypeId,
        businessUnitId: this.tableData[index].businessUnitId,
        budgetCycle: this.tableData[index].budgetCycle,
      }
      if (!isInit) {
        this.loading = true
      }
      let [, res] = await awaitWrapper(queryGrateModey(params));
      this.loading = false
      if (res && res.code == 0) {
        // for (let i = 0; i < this.tableData.length; i++) {
          // 待授予金额
          this.$set(this.tableData[index], 'pendingGrantedAmount', res.data.pendingGrantedAmount || null)
          this.setafterPendingGrantedAmount(index) // 待授予调整后金额
          // 已授予金额
          this.$set(this.tableData[index], 'grantedAmount', res.data.grantedAmount || null)
          this.setAfterGrantedAmount(index) // 已授予调整金额
        // }
      }
    },
    // 已授予调整后金额
    setAfterGrantedAmount(index) {
      // -新增已授予调整后金额="已授予金额"+"已授予调整金额（+增-减）"
      const afterGrantedAmount = plus(this.tableData[index].grantedAmount || 0, 
      this.tableData[index].adjustGrantedAmount || 0
      )
      this.$set(this.tableData[index], 'afterGrantedAmount', afterGrantedAmount)
    },
    // 待授予调整后金额
    setafterPendingGrantedAmount (index) {
      // -新增待授予调整后金额="待授予金额"+"待授予调整金额（+增-减）"
      const afterPendingGrantedAmount = plus(this.tableData[index].pendingGrantedAmount || 0, 
      this.tableData[index].adjustPendingGrantedAmount || 0
      )
      this.$set(this.tableData[index], 'afterPendingGrantedAmount', afterPendingGrantedAmount)

    },
    handleRepeatCheck(index, prop) {
      if ('5' === String(this.submitParms.ext1) && this.$store.state.userInfo.curRole.roleId == 18 && prop === 'firstDeptId') {
        const repeatId = []
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].firstDeptId) {
            if (repeatId.length > 0 && !repeatId.includes(this.tableData[i].firstDeptId)) {
              this.tableData[i].firstDeptId = null
              this.$message({
                message: "一次只能调整一个部门",
                type: "warning",
              });
            } else {
              repeatId.push(this.tableData[i].firstDeptId)
            }
          }
        }
      }
      if(['1', '2', '5'].includes(String(this.submitParms.ext1))) { // 相同预算大类调整
        this.handleRepeatCheckByType1and2(index, prop)
      }
      
    },

    handleRepeatCheckByType1and2(index, prop) { // 相同预算大类/一级部门/预算外调整
      const repeatStr = []
      for (let i = 0; i < this.tableData.length; i++) {
        const currRowInfo = this.tableData[i]
        // V3.6.2 唯一性：一级部门 + 是否待分摊 + 大类 + 类型 + 预算周期（原含事业部）
        if((currRowInfo.firstDeptId || String(currRowInfo.firstDeptId) === '0')
          && currRowInfo.shareTypeNo && currRowInfo.subjectsCatId
          && currRowInfo.subjectsTypeId && currRowInfo.cycleMonth
        ) {
          const repeatStrItem = `${currRowInfo.firstDeptId}-${currRowInfo.shareTypeNo}-${currRowInfo.subjectsCatId}-${currRowInfo.subjectsTypeId}-${currRowInfo.cycleMonth}`
          if(repeatStr.includes(repeatStrItem)) {
            // this.tableData[index][prop] = null
            this.$set(this.tableData[index], prop, null)
            toast('预算一级部门/预算大类/预算类型/是否待分摊/预算周期不能完全重复')
          } else {
            repeatStr.push(repeatStrItem)
          }
        }
      }
    },
    setSubjectsCatIdByExtType3(index) { // 设置预算大类 弹性调整多列调整
      if (String(this.submitParms.ext1) !== '3') {
        return
      }
      const subjectsCatId = this.tableData[index].subjectsCatId
      if (subjectsCatId) {
        (this.tableData || []).forEach((item, itemIndex)=>{
          this.tableData[itemIndex].subjectsCatId = subjectsCatId
          this.setChildTypeList(itemIndex)
        })
      } else {
        (this.tableData || []).forEach((item, itemIndex)=>{
          this.tableData[itemIndex].subjectsCatId = null
          this.tableData[itemIndex].subjectsTypeId = null
        })
      }
      this.emitDetailList()
    },
    setShareTypeName(index) {
      // 同步 shareType 展示文案，供提交 start.json 时使用
      if (this.tableData[index].shareTypeNo) {
        this.tableData[index].shareType = getShareTypeLabel(this.tableData[index].shareTypeNo)
      } else {
        this.tableData[index].shareType = null
      }
    },
    handleAdd(index) {
      const item = {
        _rowKey: this.genRowKey(),
        firstDeptId: null,
        subjectsCatId: null,
        subjectsTypeId: null,
        shareTypeNo: defaultShareTypeNo, // V3.6.2 新增行默认「否」
        shareType: getShareTypeLabel(defaultShareTypeNo),
        cycleMonth: null,
        adjustAmount: null,
        budgetAmount: null,
        adjustBeforeAmount: null,
        budgetImplementedAmount: null,
        freezeAmount: null,
        remainAmount: null,
        adjustAfterRemainAmount: null,
      }
      this.handleExt1Item(index, item)
    },
    handleExt1Item(index, item) {
      if (String(this.submitParms.ext1) === '1' && this.tableData[index].subjectsCatId) {
        item.subjectsCatId = this.tableData[index].subjectsCatId
        item.subjectsCatName = this.tableData[index].subjectsCatName
        this.tableData.splice(index+1, 0, item)
        this.setChildTypeList(index+1, true)
        this.emitDetailList(index+1, 'subjectsCatId')
      } else if (String(this.submitParms.ext1) === '2' && this.tableData[index].firstDeptId) {
        item.firstDeptId = this.tableData[index].firstDeptId
        item.firstDeptName = this.tableData[index].firstDeptName
        this.tableData.splice(index+1, 0, item)
        this.setChildTypeList(index+1, true)
        this.emitDetailList(index+1, 'firstDeptId')
      } else if (String(this.submitParms.ext1) === '5') {
        this.tableData.splice(index+1, 0, item)
        this.setChildTypeList(index+1, true)
        this.emitDetailList(index+1, 'firstDeptId')
      } else if (['3'].includes(String(this.submitParms.ext1))) {
        this.tableData.splice(index+1, 0, {
          ...this.tableData[index],
          _rowKey: this.genRowKey(),
          budgetCycle: null, // 预算周期
          grantedAmount: null, // 已授予金额
          // grantedAmount: this.tableData[index].grantedAmount || 0, // 已授予金额
          grantedMonth: null, // 已授予调整月份
          adjustGrantedAmount: null, // 已授予调整金额（+增-减）
          afterGrantedAmount: null, // 已授予调整后金额
          pendingGrantedAmount: null, // 待授予金额
          // pendingGrantedAmount: this.tableData[index].pendingGrantedAmount || 0, // 待授予金额
          pendingGrantedMonth: null, // 待授予调整月份
          adjustPendingGrantedAmount: null, // 待授予调整金额（+增-减）
          afterPendingGrantedAmount: null, // 待授予调整后金额
          pendingGrantedMonthList: [],
          grantedMonthList: []
        })
        this.setChildTypeList(index+1, true)
        this.emitDetailList(index+1, '')
      }
    },
    handleDel(index) {
      this.tableData.splice(index, 1)
      if (this.childTypeList && this.childTypeList.length > 0) {
        this.childTypeList.splice(index, 1)
      }
      this.emitDetailList()
    },
    // async getEhrFirstDepts() {
    //   this.loading = true
    //   let [, res] = await awaitWrapper(getEhrFirstDepts())
    //   this.loading = false
    //   this.firstDeptList = (res.data.nodes || []).map(item => {
    //       return {
    //           ...item,
    //           dicId: item.id,
    //           dicName: item.name,
    //           ehrFirstId: item.id
    //       }
    //   })
    //   this.firstDeptList = this.firstDeptList.filter((item) => {
    //     return String(item.mapid) !== "0";
    //   });
    // },
    handleDateChange(index, prop) {
      // if (this.tableData[index].month) {
      //   this.tableData[index].year = null;
      // }
      // const preMonth = [1, 2, 3, 4, 5, 6, 7];
      // const lastMonth = [8, 9, 10, 11, 12];
      // if (
      //   this.tableData[0].year === this.tableData[1].year &&
      //   ((preMonth.includes(this.tableData[0].month) &&
      //     preMonth.includes(this.tableData[1].month)) ||
      //     (lastMonth.includes(this.tableData[0].month) &&
      //       lastMonth.includes(this.tableData[1].month)))
      // ) {
      //   this.tableData[index][prop] = null;
      //   toast("当前类型，预算调整明细不能在同一预算周期");
      // }
      if (this.tableData[index].cycleMonth) { // 设置传参年月
        this.tableData[index].year = this.submitParms.alterYear
        this.tableData[index].month = this.tableData[index].cycleMonth.split('_')[0] + '年' + this.tableData[index].cycleMonth.split('_')[1] + '月';
      } else {
        this.tableData[index].year = null;
        this.tableData[index].month = null;
      }
    },
    // 是否所有调整类型都如此
    adjustAmountChange(index, validate) {
      if (validate) {
        if (String(this.tableData[index].adjustAmount) === '0') {
          toast('调整金额不允许为0')
        } else if (!this.tableData[index].adjustAmount) {
          toast('调整金额不允许为空')
        }
      }
      if (['1', '2', '5'].includes(this.submitParms.ext1)) {
        const adjustAmount = this.tableData[index].adjustAmount || 0;
        const remainAmount = this.tableData[index].remainAmount || 0;
        this.tableData[index].adjustAfterRemainAmount = plus(adjustAmount, remainAmount)
        this.$set(this.tableData[index], 'adjustAfterRemainAmount', plus(adjustAmount, remainAmount))
        this.$emit("setDetailList", this.tableData);
      }
      // if (this.submitParms.ext1 == 1 && this.submitParms.budgetType) {
      //   const adjustAmount = this.tableData[index].adjustAmount || 0;
      //   const remainAmount = this.tableData[index].remainAmount || 0;
      //   this.tableData[index].adjustAfterRemainAmount = plus(adjustAmount, remainAmount)
      // }
      // // 调整金额
      // let adjustAmount = this.tableData[index].adjustAmount || 0;
      // // 年初预算金额
      // let budgetAmount = this.tableData[index].budgetAmount || 0;
      // // 调整后半年度预算金额
      // let adjustBeforeAmount =
      //   this.tableData[index].initAdjustBeforeAmount || 0;
      // // 预算已执行金额
      // let budgetImplementedAmount =
      //   this.tableData[index].budgetImplementedAmount || 0;
      // // 预算已冻结金额
      // let freezeAmount = this.tableData[index].freezeAmount || 0;

      // adjustBeforeAmount = plus(adjustAmount, adjustBeforeAmount);
      // this.tableData[index].adjustBeforeAmount = adjustBeforeAmount;
      // this.tableData[index].adjustAfterRemainAmount = minus(
      //   minus(adjustBeforeAmount, budgetImplementedAmount),
      //   freezeAmount
      // );
    },
    // <el-option label="相同预算大类调整" value="1"></el-option>
    //       <el-option label="相同一级部门调整" value="2"></el-option>
    //       <el-option label="弹性授予调整" value="3"></el-option>
    //       <el-option label="预算期间内后期预算调前期" value="4"></el-option>
    //       <el-option label="预算外调增" value="5"></el-option>
    setFirstDeptName(index) {
      // 设置一级部门
      // let otherIndex = 1 - index;
      // if (
      //   this.alterType == 1 &&
      //   this.tableData[index].firstDeptId &&
      //   this.tableData[index].firstDeptId ==
      //   this.tableData[otherIndex].firstDeptId
      // ) {
      //   // // 相同一级部门调整
      //   // this.tableData[index].firstDeptId = null; // // 相同预算大类调整
      //   // this.tableData[index].firstDeptName = ""; //
      //   return;
      // }
      if (
        this.tableData[index].firstDeptId ||
        this.tableData[index].firstDeptId === 0 ||
        this.tableData[index].firstDeptId === "0"
      ) {
        const checkedFirstDept = this.firstDeptList.filter(
          (item) => this.tableData[index].firstDeptId == item.dicId
        );
        this.tableData[index].firstDeptName = checkedFirstDept[0].dicName;
      } else {
        this.tableData[index].firstDeptName = "";
      }
      if (this.alterType == 2 || this.alterType == 3 || this.alterType == 4) {
        // 相同一级部门调整
        this.tableData.forEach((item, itemIndex)=>{
          if (itemIndex !== index) {
            this.tableData[itemIndex].firstDeptName = this.tableData[index].firstDeptName;
            this.tableData[itemIndex].firstDeptId = this.tableData[index].firstDeptId;
          }
        })
        // this.tableData[1].firstDeptName = this.tableData[index].firstDeptName;
        // this.tableData[1].firstDeptId = this.tableData[index].firstDeptId;
      }
      // let title;
      // 设置标题名称
      // if (this.alterType == 5 && this.tableData[0].firstDeptName) {
      //   title = `${this.tableData[0].firstDeptName}年度预算调整流程`;
      // } else if (
      //   this.tableData[0].firstDeptName &&
      //   this.tableData[1].firstDeptName
      // ) {
      //   if (
      //     this.tableData[0].firstDeptName === this.tableData[1].firstDeptName
      //   ) {
      //     title = `${this.tableData[0].firstDeptName}年度预算调整流程`;
      //   } else {
      //     title = `${this.tableData[0].firstDeptName}+${this.tableData[1].firstDeptName}年度预算调整流程`;
      //   }
      // } else {
      //   title = `年度预算调整流程`;
      // }
      // this.$emit("setTitle", `年度预算调整流程`);
    },
    setInitChildType(index, add) {
      const filterBudgetType = this.budgetTypeList.filter((item) => {
        return item.dicId == this.tableData[index].subjectsCatId;
      });
      if (!add && Array.isArray(filterBudgetType) && filterBudgetType.length > 0) {
        this.childTypeList[index] = filterBudgetType[0].childrens || [];
        // this.tableData[index].subjectsCatName = filterBudgetType[0].dicName
      } else if (add && Array.isArray(filterBudgetType) && filterBudgetType.length > 0) {
        this.childTypeList.splice(index, 0, filterBudgetType[0].childrens || [])
      }
    },
    async setChildTypeList(index, isEdit) {
      console.log('this.tableData[index].subjectsCatId', this.tableData[index].subjectsCatId)
      await sleep(300)
      if (['1', '3'].includes(String(this.submitParms.ext1)) && (!this.tableData || !this.tableData[index] || !this.tableData[index].subjectsCatId)) {
        return
      } else if(!['1'].includes(String(this.submitParms.ext1)) && isEdit) {
        this.childTypeList.splice(index - 1, 0, [])
        return
      }
      const filterBudgetType = this.budgetTypeList.filter((item) => {
        return item.dicId == this.tableData[index].subjectsCatId;
      });
      if (Array.isArray(filterBudgetType) && filterBudgetType.length > 0) {
        this.childTypeList[index] = filterBudgetType[0].childrens || [];
        this.tableData[index].subjectsCatName = filterBudgetType[0].dicName;
      } else {
        this.childTypeList[index] = [];
        this.tableData[index].subjectsCatName = "";
      }
      console.log('this.childTypeList[index]', this.childTypeList[index])
      if (isEdit) {
        this.childTypeList.splice(index, 0, this.childTypeList[index])
      } else {
        this.tableData[index].subjectsTypeId = null;
        this.$set(this.childTypeList, index, this.childTypeList[index])
      }
      this.$forceUpdate()
      // console.log('childTypeList index', this.childTypeList)
    },
    setSubjectsTypeName(index) {
      // 设置预算类型名称
      if (
        this.tableData[index].subjectsTypeId ||
        this.tableData[index].subjectsTypeId === 0 ||
        this.tableData[index].subjectsTypeId === "0"
      ) {
        const checkedSubjectsType = this.childTypeList[index].filter(
          (item) => this.tableData[index].subjectsTypeId == item.dicId
        );
        this.tableData[index].subjectsTypeName = checkedSubjectsType[0].dicName;
      } else {
        this.tableData[index].subjectsTypeName = "";
      }
      if (this.alterType == 4) {
        // 相同预算大类调整
        this.tableData[1].subjectsTypeId = this.tableData[index].subjectsTypeId;
        this.tableData[1].subjectsTypeName =
          this.tableData[index].subjectsTypeName;
      }
      if (String(this.submitParms.ext1) === '3') { // 弹性调整，合并调整为一列数据同步调整
        const subjectsTypeId = this.tableData[index].subjectsTypeId || null
        const subjectsTypeName = this.tableData[index].subjectsTypeName || null
        this.tableData.forEach((item, itemIndex)=>{
          this.tableData[itemIndex].subjectsTypeId = subjectsTypeId
          this.tableData[itemIndex].subjectsTypeName = subjectsTypeName
        })
      }
      this.$set(this.tableData[index], 'subjectsTypeId', this.tableData[index].subjectsTypeId)
      this.$emit('setDetailList', this.tableData)
      this.$forceUpdate()
    },
    // 查询的数据类型 1全部组织架构[主体-归属-责任中心-一级部门-事业部][不做数据权限控制] 2科目[不做数据权限控制] 3半年度【预算周期】 4年度【预算周期】5组织架构[主体-归属-责任中心-一级部门][做数据权限控制] 6一级部门[做数据权限控制] 7科目[做数据权限控制]
    // async getOriInfo(type) {
    //   this.loading = true;
    //   let [, res] = await awaitWrapper(
    //     getOriTree({
    //       dataType: type,
    //     })
    //   );
    //   this.loading = false;
    //   if (!res || res.code != 0) {
    //     return;
    //   }
    //   // if (type == 6) {
    //   //   // 6 一级部门[做数据权限控制]
    //   //   const firstDeptList = res.data.tree || [];
    //   //   this.firstDeptList = firstDeptList.filter((item) => {
    //   //     return item.mapid !== 0 && item.mapid !== "0";
    //   //   });
    //   // }
    //   if (type == 7) {
    //     // 7 科目[做数据权限控制]
    //     this.budgetTypeList = res.data.tree || [];
    //   }
    // },
    getCycleYearAndMonth(index) {
      if (this.tableData[index].cycleMonth) {
        let year = this.tableData[index].cycleMonth.split('_')[0]
        let month = this.tableData[index].cycleMonth.split('_')[1]
        let cycleMonth = `${year}年${month}月`
        let cycleYear = `${year}${this.yearType == 1 ? '自然年' : '财年'}`
        return {
          month: cycleMonth,
          year: cycleYear
        }
      }
    },

    async queryAlterMoney(index, prop) {
      // V3.6.2：金额汇总维度改为 一级部门+大类+类型+是否待分摊+预算周期，入参用 shareTypeNo 替代 businessUnitId
      if (
        !this.tableData[index].firstDeptId ||
        !this.tableData[index].subjectsCatId ||
        !this.tableData[index].subjectsTypeId ||
        !this.tableData[index].cycleMonth ||
        !this.tableData[index].shareTypeNo
      ) {
        return;
      }
      const { year, month } = this.getCycleYearAndMonth(index)
      const params = {
        firstDeptId: this.tableData[index].firstDeptId,
        subjectsCatId: this.tableData[index].subjectsCatId,
        subjectsTypeId: this.tableData[index].subjectsTypeId,
        year,
        month,
        shareTypeNo: this.tableData[index].shareTypeNo,
      };
      this.loading = true;
      // 调整申请查询预算金额、调整后金额，冻结金额、执行后金额
      let [, res] = await awaitWrapper(queryAlterMoney(params));
      this.loading = false;
      if (res && res.data) {
        this.tableData[index].budgetAmount = res.data.budgetAmount || 0;
        this.tableData[index].adjustBeforeAmount =
          res.data.adjustBeforeAmount || 0;
        this.tableData[index].budgetImplementedAmount =
          res.data.budgetImplementedAmount || 0;
        this.tableData[index].freezeAmount = res.data.freezeAmount || 0;
        this.tableData[index].adjustAfterRemainAmount =
          res.data.adjustAfterRemainAmount || 0;
        this.tableData[index].initAdjustBeforeAmount =
          res.data.adjustBeforeAmount || 0;
        this.tableData[index].remainAmount =
          res.data.remainAmount || 0;
      } else {
        this.tableData[index].budgetAmount = 0;
        this.tableData[index].adjustBeforeAmount = 0;
        this.tableData[index].budgetImplementedAmount = 0;
        this.tableData[index].freezeAmount = 0;
        this.tableData[index].adjustAfterRemainAmount = 0;
        this.tableData[index].remainAmount = 0;
        this.tableData[index][prop] = null;
      }
      // if (res && res.data) {
      //   this.tableData[index].budgetAmount = res.data.budgetAmount || 1;
      //   this.tableData[index].adjustBeforeAmount = res.data.adjustBeforeAmount || 2;
      //   this.tableData[index].budgetImplementedAmount = res.data.budgetImplementedAmount || 3;
      //   this.tableData[index].freezeAmount = res.data.freezeAmount || 4;
      //   this.tableData[index].adjustAfterRemainAmount =
      //     res.data.adjustAfterRemainAmount || 5;
      //   this.tableData[index].initAdjustBeforeAmount =
      //     res.data.adjustBeforeAmount || 6;
      //   this.tableData[index].remainAmount =
      //     res.data.remainAmount || 7;
      // } else {
      //   this.tableData[index].budgetAmount = 1;
      //   this.tableData[index].adjustBeforeAmount = 2;
      //   this.tableData[index].budgetImplementedAmount = 3;
      //   this.tableData[index].freezeAmount = 4;
      //   this.tableData[index].adjustAfterRemainAmount = 5;
      //   this.tableData[index].remainAmount = 6;
      //   this.tableData[index][prop] = null;
      // }
      this.adjustAmountChange(index);
      this.$emit("setDetailList", this.tableData);
      // console.log("this.tableData[index].adjustBeforeAmount", this.tableData[index].adjustBeforeAmount)
    },
    // 导入成功再emit @change="emitParms"';
    async emitDetailList(index, prop, isInit) {
      console.log('emitDetailList index', index, prop, isInit)
      if (!this.validateDetailList(index, prop)) {
        return
      }
      this.$emit("setDetailList", this.tableData);
      // console.log("index", index)
      // console.log('index, prop', index, prop)
      if (this.submitParms.ext1 === '3' && ['firstDeptId', 'subjectsCatId', 'subjectsTypeId', 'budgetCycle', 'businessUnitId'].includes(prop)) {
        if (prop === 'budgetCycle') {
          this.getGrantedAmount(index, prop, isInit); // 查询弹性授予金额明细
        } else {
          this.setBudgetCycleChange(isInit, prop)
        }
      } else if (prop && ['firstDeptId', 'subjectsCatId', 'subjectsTypeId', 'cycleMonth', 'shareTypeNo'].includes(prop)) {
        this.queryAlterMoney(index, prop); // 维度字段变更时重查预算金额
        await sleep(100);
        this.$emit("setDetailList", this.tableData);
      }
    },
    // 弹性验证重复
    validateDetailListByExtType3(index, prop) {
      const diffTableRepeatList = []
      let repeatIndexList = []
      // 2个表格之间  预算一级部门+预算大类+预算类型+事业部"不能重复
      let listRepeat = false
      this.submitParms.detailList.forEach((detailList, detailListIndex)=>{
        // console.log('detailList', `${detailList[0].firstDeptId}_${detailList[0].subjectsCatId}_${detailList[0].subjectsTypeId}_${detailList[0].businessUnitId}`)
        if (!listRepeat && Array.isArray(detailList) && detailList.length > 0
        && detailList[0].firstDeptId && detailList[0].subjectsCatId
        && detailList[0].subjectsTypeId && detailList[0].businessUnitId
        ) {
          repeatIndexList.push({
            key: `${detailList[0].firstDeptId}_${detailList[0].subjectsCatId}_${detailList[0].subjectsTypeId}_${detailList[0].businessUnitId}`,
            index: detailListIndex
          })
          const str = `${detailList[0].firstDeptId}_${detailList[0].subjectsCatId}_${detailList[0].subjectsTypeId}_${detailList[0].businessUnitId}`
          // console.log('str', str)
          // console.log('diffTableRepeatList', diffTableRepeatList)
          if (diffTableRepeatList.includes(str) && !listRepeat) {
            repeatIndexList = repeatIndexList.filter(item=>item.index !== this.dataIndex && item.key === str)
            console.log('repeatIndexList', repeatIndexList)
            console.log('prop', prop)
            toast(`预算一级部门/预算大类/预算类型/事业部和调整明细${repeatIndexList[0].index + 1}完全重复`)
            // this.tableData[repeatIndexList[0].index][prop] = null
            this.tableData.forEach((item, itemIndex)=>{
              this.$set(this.tableData[itemIndex], prop, null)
            })
            this.$emit('setDetailList', this.tableData)
            listRepeat = true
          }
          diffTableRepeatList.push(str)
        }
      })
      if (listRepeat) {
        return false
      }
      // if (isRepeat(diffTableRepeatList)) {
      //   toast('调整明细间预算一级部门/预算大类/预算类型/事业部不能完全重复')
      //   this.tableData.forEach((item, index)=>{
      //     this.tableData[index][prop] = null
      //   })
      //   this.$emit('setDetailList', this.tableData)
      //   return false
      // }
      if (prop === 'budgetCycle') {
        const rowRepeatList = []
        this.tableData.forEach((item, index)=>{
          if (item.firstDeptId && item.subjectsCatId && item.subjectsTypeId && item.businessUnitId && item.budgetCycle) {
            rowRepeatList.push(`${item.firstDeptId}_${item.subjectsCatId}_${item.subjectsTypeId}_${item.businessUnitId}_${item.budgetCycle}`)
          }
        })
        if(isRepeat(rowRepeatList)) {
          toast('预算一级部门/预算大类/预算类型/事业部/预算周期不能完全重复')
          this.tableData[index][prop] = null
          this.$emit('setDetailList', this.tableData)
          return false
        }
      }
      return true
    },
    validateDetailList (index, prop) {
      // V3.6.2：校验行唯一性 — 一级部门 + 大类 + 类型 + 是否待分摊 + 预算周期
      let keyList = (this.tableData || []).filter(item=>{
        // V3.6.2：行内唯一性 key，不含事业部
        return item.firstDeptId && item.subjectsCatId && item.subjectsTypeId && item.shareTypeNo && item.cycleMonth
      }).map(item=>{
        return `${item.firstDeptId}_${item.subjectsCatId}_${item.subjectsTypeId}_${item.shareTypeNo}_${item.cycleMonth}`
      })
      if (isRepeat(keyList)) {
        toast('预算一级部门/预算大类/预算类型/是否待分摊/预算周期不能完全重复')
        this.$set(this.tableData[index], prop, null)
        return false
      } else {
        return true
      }
    },
    summaryMethod(param) {
      const { columns, data } = param;
      const sumData = this.useCommonTable ? data : this.tableData;
      const sums = [];
      const needSumsLabelList = [
        "调整金额",
        "调整金额（+增-减）",
        "预算编制金额",
        "预算已调整金额",
        "预算已执行金额",
        "预算已冻结金额",
        "预算剩余金额",
        "调整后预算剩余金额",
        "已授予金额",
        "已授予调整金额（+增-减）",
        "已授予调整后金额",
        "待授予金额",
        "待授予调整金额（+增-减）",
        "待授予调整后金额"
      ];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = sumData.map((item) => Number(item[column.property]));
        if (
          needSumsLabelList.includes(column.label) &&
          !values.every((value) => isNaN(value))
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.dealWithMoney(sums[index]);
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    dealWithMoney(value) {
      if (!value && value !== "0" && value !== 0) {
        return "--";
      } else {
        return this.$options.filters.currency(
          this.$options.filters.unitMoney(value, 1),
          "￥",
          2
        );
      }
    },
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (String(this.submitParms.ext1) === '3') {
        if (['firstDeptId', 'subjectsCatId', 'subjectsTypeId', 'businessUnitId'].includes(column.property)) {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 100%;
}
</style>